import {Component} from '@angular/core';

@Component({
  selector: 'goto-node',
  templateUrl: './goto-node.component.html'
})
export class GotoNodeComponent {
    node
}
